<!-- <template>
  <v-container>
    <div class="tituloOnco tituloEscritorio">
      <div class="headerBack">
        <div style="display: flex; justify-content: center; gap: 47%">
          <div style="margin-top: 1%;">
            <img :src="logoSouthbrigde" alt="Southbrigde" >
          </div>
          <div style="margin-top: 2%;" class="textHeaderOnco">
            SEGURO ONCOLÓGICO IRAM
          </div>
        </div>
      </div>
      
    </div>

    <div class="tituloOnco tituloMobile">
      <div class="headerBack">
        <div  class="headerFlex">
          <div style="margin-top: 1%;">
            <img :src="logoSouthbrigde" alt="Southbrigde" >
          </div>
          <div style="margin-top: 2%;" class="textHeaderOnco">
            SEGURO ONCOLÓGICO IRAM
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template> -->
<template>
  <v-container>
   <!-- Escritorio -->
    <div v-if="isDesktop" class="tituloEscritorio">
      <img :src="barraFondo" style="width: -webkit-fill-available;"  alt="Imagen Escritorio" />
    </div>

    <!-- Móvil -->
    <div v-else class="tituloMobile">
      <img :src="barraFondoMobile" alt="Imagen Móvil" />
    </div>
  </v-container>
</template>

<script>
// import barraFondo from '@/assets/images/HeaderIram.png'; 
// import barraFondoMobile from '@/assets/images/barraFondoMobile.png';
import barraFondo from '@/assets/images/barraTitulo.svg'; 
import barraFondoMobile from '@/assets/images/barraFondoMobile.svg'; 
import logoSouthbrigde from '@/assets/images/newLogo.png';


export default {
  name: "Titulo",
  data: () => {
    return {
      barraFondo,
      barraFondoMobile,
      logoSouthbrigde,
      titulo: '',
      isDesktop: false,
    };
  },
   mounted() {
    this.checkScreen()
    window.addEventListener("resize", this.checkScreen)
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreen)
  },
  methods: {
    checkScreen() {
      this.isDesktop = window.innerWidth > 800
    }
  }
}
</script>

<style lang="scss">
.v-container {
  justify-content: center;
  align-items: center;
  /* Agregamos alineación vertical al centro */
}
// @media (min-width: 1264px) {
//     .container {
//         max-width: 100%;
//     }
// }

/* Estilo principal de la barra */
/* Barra común */
.tituloOnco {
  display: none; /* Ocultar por defecto */
  // justify-content: center;
  // max-width: 102%;
  // overflow: hidden; 
}

/* Imagen de escritorio: mostrar solo en pantallas grandes */

.tituloEscritorio {
  margin-top: 0%;
  max-width: 100%;
  // height: 72px; 
  object-fit: contain;
}


.tituloOnco img {
  max-width: 100%;
  height: 70px; 
  object-fit: contain;
}

/* Imagen de móvil: mostrar solo en pantallas pequeñas */

  .tituloMobile {
    display: flex; /* Mostrar en móvil */
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 50px;
     max-width: 100%;
    height: 70px; 
    object-fit: contain;
  }

  .tituloMobile img {
    width: 100%;
    height: 127px;
    margin-top: 13%;
  }

</style>